module.exports = __webpack_public_path__ + "static/media/google-sheets.92a38967.svg";